import Splide from '@splidejs/splide'
import Alpine from 'alpinejs'

export const initShowSlider = () => {
    Alpine.data('initShowSlider', () => ({
        init() {
            const splide = new Splide(this.$el, {
                arrows: true,
                pagination: false,
                perMove: 1,
                updateOnMove: true,
                focus: 0,
                omitEnd: true,
                mediaQuery: 'min',
                lazyLoad: 'sequential',
                breakpoints: {
                    0: {
                        perPage: 1.1,
                        gap: 15,
                    },
                    475: {
                        perPage: 1.5,
                        gap: 15,
                    },
                    768: {
                        perPage: 2.3,
                        gap: 20,
                    },
                    1024: {
                        perPage: 2.8,
                        gap: 20,
                    },
                    1200: {
                        perPage: 3.3,
                        gap: 20,
                    },
                    1600: {
                        perPage: 4.3,
                        gap: 20,
                    },
                },
            })

            // event on overflowing content to enable / disable interactions
            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                }
            })

            splide.mount()
        },
    }))
}
